import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';

import React, { PureComponent } from 'react';

import { getAll as getPrograms } from 'actions/programs';
import { Module } from '@cuemath/comps';
import Program from './view';

class ProgramContainer extends PureComponent {
  static defaultProps = {
    programs: null,
  };

  static propTypes = {
    programs: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    actions: PropTypes.shape({
      getPrograms: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  componentDidMount() {
    this.refreshData();
  }

  refreshData = () => {
    const { actions } = this.props;

    actions.getPrograms();
  };

  render() {
    const { programs } = this.props;
    const { match } = this.props;
    return (
      <Module
        module={Program}
        resource={programs || {}}
        programs={programs ? programs.data : {}}
        permissions={programs ? programs.permissions : {}}
        match={match}
      />
    );
  }
}

export default connect(
  ({ programs }) => ({
    programs: store.getAll(programs),
  }),
  dispatch => ({
    actions: bindActionCreators({ getPrograms }, dispatch),
  }),
)(ProgramContainer);
